export enum ExportControlLevel {
  Yellow = 'Yellow',
  Red = 'Red',
}
